import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Performance } from '../model/recital';

export interface CreatePerformanceParams {
  actId: string;
  name: string;
  orderIndex: number;
  duration: number;
  classIds: Array<string>;
  studentIds?: Array<string>;
  description?: string;
}

export const createPerformanceAPI = async ({
  actId,
  ...params
}: CreatePerformanceParams) => {
  const response = await baseAPI.post<Performance>(
    `/acts/${actId}/performances`,
    params,
  );
  return response.data;
};

export const useCreatePerformanceMutation = () => {
  return useMutation({
    mutationFn: async (params: CreatePerformanceParams) => {
      return await createPerformanceAPI(params);
    },
    onSuccess: (data) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACTS, data.actId, KEYS.PERFORMANCES],
      });
    },
    onError: (error: AxiosError<{ message: string }>) => {
      const errorMessage =
        error.response?.data.message ?? 'Failed to create performance';
      toast.error(errorMessage);
    },
  });
};
